/* Zərf tema skripti. Asılılıq yoxdur. */
(function () {
  'use strict';

  var doc = document, root = doc.documentElement;
  root.classList.add('js');
  var cfg = window.ZerfConfig || {};
  var routes = cfg.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Pul formatı: Shopify mağaza formatı ilə eyni, .00 olan qiymətlərdə sıfırlar atılır */
  function formatMoney(cents, format) {
    var f = format || '{{amount}}', re = /\{\{\s*(\w+)\s*\}\}/;
    var whole = cents % 100 === 0;
    function fmt(n, p, t, d) {
      t = t || ','; d = d || '.';
      var s = (n / 100).toFixed(p).split('.');
      var out = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return s[1] && !(whole && /^0+$/.test(s[1])) ? out + d + s[1] : out;
    }
    var m = f.match(re), v = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' '); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      default: v = fmt(cents, 2);
    }
    return f.replace(re, v);
  }
  function money(cents) { return formatMoney(cents, cfg.moneyFormat); }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Səbət ---------- */
  var Cart = {
    data: null,
    veil: null, drawer: null,
    init: function () {
      this.veil = $('[data-veil]');
      this.drawer = $('[data-drawer]');
      if (!this.drawer) return;
      this.refresh();
      var self = this;
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
    },
    refresh: function () {
      var self = this;
      return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.data = c; self.render(); return c; })
        .catch(function () {});
    },
    render: function () {
      var c = this.data; if (!c) return;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      var box = $('[data-cart-lines]');
      if (!box) return;
      box.innerHTML = c.items.length ? c.items.map(function (it) {
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        var img = it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" width="64" height="85" loading="lazy">' : '<span></span>';
        return '<div class="line">' + img +
          '<div><h4>' + esc(it.product_title) + '</h4>' + variant +
          '<small>' + esc(money(it.final_price)) + '</small>' +
          '<div class="mini"><button type="button" data-line-change="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Azalt">&minus;</button>' +
          '<output>' + it.quantity + '</output>' +
          '<button type="button" data-line-change="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Artır">+</button></div></div>' +
          '<div><div class="line-total">' + esc(money(it.final_line_price)) + '</div>' +
          '<button type="button" class="rm" data-line-change="' + esc(it.key) + '" data-q="0">Sil</button></div></div>';
      }).join('') : '<p class="empty">' + esc(cfg.emptyText || 'Səbət boşdur.') + '</p>';
      var total = $('[data-cart-total]'); if (total) total.textContent = money(c.total_price);
      var go = $('[data-checkout]'); if (go) go.disabled = !c.items.length;
    },
    change: function (key, q) {
      var self = this;
      return fetch(routes.change + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items) { self.data = c; self.render(); } })
        .catch(function () {});
    },
    add: function (form) {
      var self = this;
      return fetch(routes.add + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; });
      }).then(function () { return self.refresh(); }).then(function () { self.open(); });
    },
    open: function () {
      if (!this.drawer) return;
      this.veil.hidden = false; this.drawer.hidden = false;
      var x = $('[data-close-cart]'); if (x) x.focus();
    },
    close: function () {
      if (!this.drawer || this.drawer.hidden) return;
      this.veil.hidden = true; this.drawer.hidden = true;
      var b = $('[data-open-cart]'); if (b) b.focus();
    }
  };

  /* ---------- Sol menyu ---------- */
  var Menu = {
    nav: null, veil: null, btn: null, timer: 0,
    init: function () {
      // menyu yapışqan başlığın içində qalarsa, başqa qatların altında qalır; ona görə <body>-yə köçürülür
      var nav = $('[data-menu]'), veil = $('[data-menu-veil]');
      if (!nav) return;
      $$('body > [data-menu], body > [data-menu-veil]').forEach(function (el) { if (el !== nav && el !== veil) el.remove(); });
      if (veil && veil.parentNode !== doc.body) doc.body.appendChild(veil);
      if (nav.parentNode !== doc.body) doc.body.appendChild(nav);
      this.nav = nav; this.veil = veil; this.btn = $('[data-open-menu]');
      // Cari səhifəni işarələ (məs. /collections/all?sort_by=...)
      var path = location.pathname.replace(/\/$/, '') || '/';
      $$('.mlinks a', nav).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '/' || href.indexOf('#') > -1) return;
        var h = href.replace(/\/$/, '') || '/';
        if (h === path) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
      });
    },
    isOpen: function () { return !!this.nav && !this.nav.hidden && root.classList.contains('menu-open'); },
    open: function () {
      if (!this.nav) return;
      Cart.close();
      clearTimeout(this.timer);
      this.nav.hidden = false; if (this.veil) this.veil.hidden = false;
      void this.nav.offsetWidth; // keçid animasiyası üçün
      root.classList.add('menu-open');
      if (this.btn) this.btn.setAttribute('aria-expanded', 'true');
      var x = $('[data-close-menu]', this.nav); if (x) x.focus();
    },
    close: function (noFocus) {
      if (!this.isOpen()) return;
      var self = this;
      root.classList.remove('menu-open');
      if (this.btn) { this.btn.setAttribute('aria-expanded', 'false'); if (!noFocus) this.btn.focus(); }
      this.timer = setTimeout(function () { self.nav.hidden = true; if (self.veil) self.veil.hidden = true; }, 320);
    }
  };

  /* ---------- Kartdan sürətli əlavə ---------- */
  function quickAdd(form) {
    var btn = $('button[type=submit]', form);
    if (!btn || btn.disabled) return;
    var html = btn.innerHTML;
    btn.disabled = true;
    Cart.add(form).then(function () {
      btn.classList.add('is-done');
      btn.textContent = 'Əlavə olundu';
      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = html; btn.disabled = false; }, 1600);
    }).catch(function () { btn.disabled = false; form.submit(); });
  }

  /* ---------- Səbət səhifəsi ---------- */
  function initCartPage() {
    var form = $('[data-cart-form]'); if (!form || form.__zerf) return; form.__zerf = true;
    var upd = $('[data-cart-update]', form), t = 0;
    function submit() {
      clearTimeout(t);
      t = setTimeout(function () {
        if (form.requestSubmit && upd) form.requestSubmit(upd);
        else if (upd) upd.click();
      }, 450);
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]'); if (!b) return;
      var input = $('[data-cart-qty]', b.parentNode); if (!input) return;
      input.value = Math.max(0, Math.min(99, (+input.value || 0) + (+b.getAttribute('data-step'))));
      submit();
    });
    form.addEventListener('change', function (e) { if (e.target.matches('[data-cart-qty]')) submit(); });
  }

  /* ---------- Dizayn (vurğu rəngi) ---------- */
  function setDesign(handle) {
    if (handle) root.setAttribute('data-design', handle); else root.removeAttribute('data-design');
  }

  /* ---------- Məhsul bölməsi ---------- */
  function initProduct(sec) {
    if (sec.__zerf) return; sec.__zerf = true;
    var jsonEl = $('[data-product-json]', sec); if (!jsonEl) return;
    var P = JSON.parse(jsonEl.textContent);
    var form = $('.buy-form', sec);
    var idInput = $('[data-variant-input]', sec);
    var state = { opts: [], variant: null, media: null };
    var cur = P.variants.filter(function (v) { return v.id === P.current; })[0] || P.variants[0];
    state.opts = cur.options.slice();

    function findVariant() {
      return P.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === state.opts[i]; });
      })[0] || null;
    }

    function showMedia(id) {
      var slides = $$('[data-slide]', sec), found = false;
      slides.forEach(function (s) { if (s.getAttribute('data-slide') === String(id)) found = true; });
      if (!found) id = slides.length ? slides[0].getAttribute('data-slide') : null;
      state.media = id;
      slides.forEach(function (s) {
        var on = s.getAttribute('data-slide') === String(id);
        s.hidden = !on;
        if (!on) $$('video', s).forEach(function (v) { try { v.pause(); } catch (e) {} });
      });
      $$('[data-thumb]', sec).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false'); });
      updateTag();
    }
    function updateTag() {
      var tag = $('[data-stage-tag]', sec); if (!tag) return;
      if (state.media === 'anim') { tag.textContent = tag.getAttribute('data-anim-label') || ''; tag.hidden = !tag.textContent; }
      else { tag.textContent = P.hasOptions ? state.opts[0] : ''; tag.hidden = !tag.textContent; }
    }

    function update(fromUser) {
      var v = findVariant(); state.variant = v;
      $$('[data-opt-index]', sec).forEach(function (b) {
        b.setAttribute('aria-pressed', state.opts[+b.getAttribute('data-opt-index')] === b.getAttribute('data-value') ? 'true' : 'false');
      });
      $$('[data-opt-label]', sec).forEach(function (l) { l.textContent = state.opts[+l.getAttribute('data-opt-label')]; });
      var sw = $('[data-opt-index="0"][aria-pressed="true"]', sec);
      setDesign(sw ? sw.getAttribute('data-handle') : '');
      document.dispatchEvent(new CustomEvent('zerf:design', { detail: { value: state.opts[0] } }));

      var add = $('[data-add]', sec), sAdd = $('[data-add-sticky]', sec);
      var priceEl = $('[data-price]', sec), cmp = $('[data-compare]', sec);
      if (v) {
        idInput.value = v.id;
        priceEl.textContent = v.price;
        cmp.textContent = v.compare; cmp.hidden = !v.compare;
        add.disabled = sAdd.disabled = !v.available;
        add.textContent = sAdd.textContent = v.available ? P.addLabel : P.soldOutLabel;
        $('[data-sbar-price]', sec).textContent = v.price;
        var simg = $('[data-sbar-img]', sec); if (simg && v.image) simg.src = v.image;
        if (fromUser && v.media) showMedia(v.media);
        try { var u = new URL(location.href); if (P.isProductPage) { u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } } catch (e) {}
      } else {
        add.disabled = sAdd.disabled = true;
        add.textContent = sAdd.textContent = P.unavailableLabel;
      }
      var sn = $('[data-sbar-name]', sec); if (sn) sn.textContent = P.hasOptions ? state.opts[0] : P.title;
      updateTag();
    }

    sec.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !sec.contains(t)) return;
      if (t.hasAttribute('data-opt-index')) { state.opts[+t.getAttribute('data-opt-index')] = t.getAttribute('data-value'); update(true); }
      else if (t.hasAttribute('data-thumb')) showMedia(t.getAttribute('data-thumb'));
      else if (t.hasAttribute('data-qty-minus')) { var q = $('[name=quantity]', sec); q.value = Math.max(1, (+q.value || 1) - 1); }
      else if (t.hasAttribute('data-qty-plus')) { var q2 = $('[name=quantity]', sec); q2.value = Math.min(99, (+q2.value || 1) + 1); }
    });

    document.addEventListener('zerf:pick', function (e) {
      var b = $$('[data-opt-index="0"]', sec).filter(function (x) { return x.getAttribute('data-value') === e.detail.value; })[0];
      if (!b) return;
      state.opts[0] = e.detail.value;
      // başqa seçimlər bu dizaynda mövcud deyilsə, uyğun variantı tapmağa çalış
      if (!findVariant()) {
        var alt = P.variants.filter(function (v) { return v.options[0] === state.opts[0]; })[0];
        if (alt) state.opts = alt.options.slice();
      }
      update(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !FormData) return;
      e.preventDefault();
      var add = $('[data-add]', sec), err = $('[data-form-error]', sec);
      if (add.disabled) return;
      err.hidden = true;
      add.disabled = true;
      Cart.add(form).catch(function (ex) {
        err.textContent = ex && ex.message && ex.message !== 'error' ? ex.message : (P.errorText || 'Səbətə əlavə etmək alınmadı.');
        err.hidden = false;
      }).then(function () {
        var q = $('[name=quantity]', sec); if (q) q.value = 1;
        update(false);
      });
    });

    // yapışqan mobil zolaq
    var sb = $('[data-sbar]', sec), addBtn = $('[data-add]', sec);
    if (sb && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sb.classList.toggle('show', show);
        sb.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = $('[data-add-sticky]', sb); if (b) b.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
    }

    update(false);
    showMedia(cur.media || (P.startAnim ? 'anim' : null));
  }

  /* ---------- Dizayn kartları ---------- */
  function initDesigns(sec) {
    if (sec.__zerf) return; sec.__zerf = true;
    function mark(value) {
      $$('.card', sec).forEach(function (c) {
        var on = c.getAttribute('data-value') === value;
        c.setAttribute('aria-current', on ? 'true' : 'false');
        var b = $('button', c);
        b.textContent = on ? b.getAttribute('data-label-on') : b.getAttribute('data-label');
      });
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick]'); if (!b) return;
      document.dispatchEvent(new CustomEvent('zerf:pick', { detail: { value: b.getAttribute('data-pick') } }));
    });
    document.addEventListener('zerf:design', function (e) { mark(e.detail.value); });
    var first = $('.card', sec);
    var active = $('[data-opt-index="0"][aria-pressed="true"]');
    if (active) mark(active.getAttribute('data-value'));
  }

  /* ---------- Animasiya idarəsi ---------- */
  var speed = 0.5;
  function applySpeed() {
    root.style.setProperty('--T', (9 / speed) + 's');
    $$('[data-speed]').forEach(function (b) { b.setAttribute('aria-pressed', parseFloat(b.getAttribute('data-speed')) === speed ? 'true' : 'false'); });
  }

  function initAll(scope) {
    $$('[data-product-section]', scope).forEach(initProduct);
    $$('[data-designs-section]', scope).forEach(initDesigns);
  }

  doc.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t) return;
    if (t.hasAttribute('data-speed')) { speed = parseFloat(t.getAttribute('data-speed')); applySpeed(); }
    else if (t.hasAttribute('data-pause')) {
      var ps = root.classList.toggle('anim-paused');
      t.setAttribute('aria-pressed', String(ps));
      t.textContent = ps ? t.getAttribute('data-label-on') : t.getAttribute('data-label');
    }
    else if (t.hasAttribute('data-open-menu')) { e.preventDefault(); if (Menu.isOpen()) Menu.close(); else Menu.open(); }
    else if (t.hasAttribute('data-close-menu')) Menu.close();
    else if (t.closest('[data-menu]') && t.tagName === 'A') Menu.close(true);
    else if (t.hasAttribute('data-open-cart')) { if (Cart.drawer && !doc.body.classList.contains('template-cart')) { e.preventDefault(); Menu.close(true); Cart.open(); } }
    else if (t.hasAttribute('data-close-cart')) Cart.close();
    else if (t.hasAttribute('data-line-change')) Cart.change(t.getAttribute('data-line-change'), +t.getAttribute('data-q'));
  });
  doc.addEventListener('click', function (e) {
    if (Cart.veil && e.target === Cart.veil) Cart.close();
    if (Menu.veil && e.target === Menu.veil) Menu.close();
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { Menu.close(); Cart.close(); } });
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.classList && f.classList.contains('quick-add') && window.fetch && window.FormData) { e.preventDefault(); quickAdd(f); }
  });
  doc.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('select[data-sort]')) return;
    try { var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); }
    catch (ex) { location.search = '?sort_by=' + encodeURIComponent(sel.value); }
  });

  function ready() {
    Menu.init();
    initCartPage();
    Cart.init();
    applySpeed();
    initAll(doc);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready); else ready();

  // tema redaktorunda bölmələr yenidən yüklənəndə
  doc.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    if ($('[data-menu]', e.target)) Menu.init();
    initCartPage();
  });
  window.Zerf = { cart: Cart, formatMoney: formatMoney };
})();
